module.exports = __webpack_public_path__ + "static/media/android_2.61bb5f25.png";